import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdTextField} from "../../core/components/fields/fields";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {ProjectVersionCapacity} from "../domain/project/projectVersionCapacitiesDomain";

@observer
class ProjectVersionCapacitiesForm extends React.Component<FormProps<ProjectVersionCapacity, ProjectVersionCapacity>,any> {

  render() {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionCapacitiesFormDefinition.formName);
    let {area, countOfHousingUnits, countOfPeople} = fields;

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <MdTextField {...area.props} />
            <Validate field={area} value={area.props.value}/>
          </div>
          <div className="col-xs-12">
            <MdTextField {...countOfHousingUnits.props} />
            <Validate field={countOfHousingUnits} value={countOfHousingUnits.props.value}/>
          </div>
          <div className="col-xs-12">
            <MdTextField {...countOfPeople.props} />
            <Validate field={countOfPeople} value={countOfPeople.props.value}/>
          </div>
        </div>

      </div>
    );

  }
}

export const ProjectVersionCapacitiesFormDefinition: DefinitionType = {
  formName: 'ProjectVersionCapacitiesForm',
  fields: [
    {name: 'area',validators: [ 'IsNumber']},
    {name: 'countOfHousingUnits',validators: ['IsNumber']},
    {name: 'countOfPeople',validators: ['IsNumber']},
  ]
};

export default createForm(ProjectVersionCapacitiesFormDefinition, null)(ProjectVersionCapacitiesForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectCapacitiesForm.tsx